export const AVAILABILITY_POLLING_PERIOD_MS = 3 * 60_000;
export const HEARTBEAT_INTERVAL = 60_000;
export const CHECK_IN_FREQUENCY_BEFORE_OPENING_TIME_MS = 270_000;
export const CHECK_IN_FREQUENCY_AFTER_OPENING_TIME_MS = 60_000;
export const BUSY_MODE_DURATION_MINS = 30;
